import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M21.5 2.5h-19A2.5 2.5 0 0 0 0 5v14a2.5 2.5 0 0 0 2.5 2.5h19A2.5 2.5 0 0 0 24 19V5a2.5 2.5 0 0 0-2.5-2.5M16.53 16a.75.75 0 0 1 0 1.06.75.75 0 0 1-1.06 0l-3.54-3.54L8.4 17a.74.74 0 0 1-.53.22.73.73 0 0 1-.53-.22.75.75 0 0 1 0-1.06l3.53-3.54-3.53-3.5a.75.75 0 0 1 0-1.06.74.74 0 0 1 1.06 0l3.53 3.53 3.54-3.53a.74.74 0 0 1 1.06 0 .75.75 0 0 1 0 1.06L13 12.43Z"
    }, null, -1)
  ]));
}
const interfaceAlertErrorXBlockSquare = { render };
export {
  interfaceAlertErrorXBlockSquare as default,
  render
};
//# sourceMappingURL=interface-alert-error-x-block-square.svg.js.map
